import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import spinner from 'images/spinner@2x.gif';

class SpinnerIcon extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    return <img src={spinner} width="24" height="24" />;
  }
}

export default SpinnerIcon;
